import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-section08',
    templateUrl: './section08.component.html',
    styleUrls: ['./section08.component.scss']
})

export class Section08Component implements OnInit {
    @Input() data;

    constructor() {
    }

    ngOnInit() {
    }
}
